import React from "react";
import { makeStyles, Typography } from "@material-ui/core";
import { FormattedHTMLMessage, FormattedMessage } from "react-intl";
import { newColumnText, newColumnValueWithNumberComponent, TableList } from "../../TableList";
import { useTableOptions } from "../../../../util/tableOptionsMaterialTable";

const months = ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"];

const useStyles = makeStyles((theme) => ({
  title: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    marginBottom: theme.spacing(2),
  },
}));

const MonthlyIncomeTable = ({ user, currentUser, message, year, data, valueLabelId = "app.yield" }) => {
  const classes = useStyles();
  const options = useTableOptions({
    toolbar: false,
  });

  const columns = React.useMemo(() => {
    return [
      newColumnText("app.month", "month", (row) => <FormattedMessage id={`app.month.${row.month}`} />),
      newColumnValueWithNumberComponent(valueLabelId, "value", user.taxResidence, currentUser.hideValues, true),
    ];
  }, [currentUser.hideValues, user.taxResidence, valueLabelId]);

  const tableData = React.useMemo(() => {
    return months.map((month, index) => ({
      month,
      value: data?.[index] ?? 0,
    }));
  }, [data]);

  return (
    <>
      <Typography
        gutterBottom
        variant="h6"
        color="primary"
        className={classes.title}
      >
        <FormattedMessage id="app.earnings.contractsHistoryByMonth" />
      </Typography>
      {message && (
        <Typography variant="body2">
          <FormattedHTMLMessage
            id={message}
            values={{ year }}
          />
        </Typography>
      )}
      <TableList
        columns={columns}
        country={currentUser.taxResidence}
        data={tableData}
        options={options}
        user={currentUser}
      />
    </>
  );
};

export default MonthlyIncomeTable;
